import React, { memo } from "react";
import './TableInfoCell.scss';

const TableInfoCell = memo(({
  children,
}) => {
  return (
    <div className="table-info-cell">
      {children}
    </div>
  );
});

export default TableInfoCell;
